module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/PreviewBlack.35ea51e2.svg";